export default '2.6.0';
